import { Module } from 'vuex';

import hotelStore from './modules/hotel';
import bookingStore from './modules/booking';
import { Source } from '@/constants/source';
import { LandingSettingsInterface, SettingsStoreInterface } from '@/types/store/landing/settingsStoreInterface';

const getDefaultState = (): LandingSettingsInterface => {
  return {
    booking_data: {
      room_type_hid: '',
      meal_option: 0,
      checkin: '',
      checkout: '',
      guests_number: 0,
      rooms_number: 0,
    },
    booking_request_expiration_in: 0,
    amenities: [],
    prefectures: [],
    account_source: Source.WithoutSource,
    payment_system: undefined,
    locales: {},
    testing_mode: true,
  };
};

const store: Module<SettingsStoreInterface, any> = {
  namespaced: true,
  modules: {
    hotel: hotelStore,
    booking: bookingStore,
  },
  state: {
    settings: getDefaultState(),
  },
  mutations: {
    setSettings(state, settings: LandingSettingsInterface) {
      state.settings = { ...state.settings, ...settings };
    },
  },
  actions: {
    init({ state, dispatch }) {
      type keyInterface = keyof LandingSettingsInterface | string;
      const defaultKeys: Array<keyInterface> = Object.keys(getDefaultState()).sort();
      const currentKeys: Array<keyInterface> = Object.keys(state.settings).sort();
      defaultKeys.forEach((key: keyInterface) => {
        if (!currentKeys.includes(key)) {
          dispatch('clearAll');
          return;
        }
      });
    },
    clearAll({ dispatch }, data) {
      dispatch('hotel/resetState', data);
      dispatch('booking/resetState');
    },
  },
};

export default store;
